type IconProps = {
  color?: string;
  backgroundColor?: string;
  size?: number;
  className?: string;
};

export function IconIncomingForNav({
  className,
}: {
  className?: string;
}) {
  return (
    <IconIncoming className={className} color="currentColor" size={20} />
  );
}

export function IconIncoming({
  color = "#3D3935",
  backgroundColor,
  size = 26,
  className,
}: IconProps) {
  const bgColor = backgroundColor || color;

  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#icon-incoming-clip)">
        <path
          opacity="0.4"
          d="M2.05266 11.7677C1.80206 11.6125 1.48709 11.6053 1.2296 11.7487C0.972117 11.8921 0.8125 12.1638 0.8125 12.4585V19.7516C0.812492 20.6322 0.812486 21.3424 0.859478 21.9176C0.907862 22.5098 1.01008 23.0299 1.25529 23.5112C1.64477 24.2756 2.26626 24.8971 3.03066 25.2865C3.5119 25.5317 4.03205 25.634 4.62424 25.6824C5.19939 25.7293 5.90963 25.7293 6.7902 25.7293H19.2098C20.0904 25.7293 20.8006 25.7293 21.3758 25.6824C21.9679 25.634 22.4881 25.5317 22.9693 25.2865C23.7337 24.8971 24.3552 24.2756 24.7447 23.5112C24.9899 23.0299 25.0921 22.5098 25.1405 21.9176C25.1875 21.3424 25.1875 20.6322 25.1875 19.7516V12.4585C25.1875 12.1638 25.0279 11.8921 24.7704 11.7487C24.5129 11.6053 24.1979 11.6125 23.9473 11.7677L14.8532 17.3974C13.9751 17.9409 13.6956 18.1015 13.4169 18.1643C13.1424 18.2262 12.8576 18.2262 12.5831 18.1643C12.3044 18.1015 12.0249 17.9409 11.1468 17.3974L2.05266 11.7677Z"
          fill={bgColor}
        />
        <path
          d="M4.60547 2.7085C4.60547 1.3623 5.69677 0.270996 7.04297 0.270996H18.9596C20.3058 0.270996 21.3971 1.3623 21.3971 2.7085V10.8335C21.3971 11.2822 21.0334 11.646 20.5846 11.646C20.1359 11.646 19.7721 11.2822 19.7721 10.8335V2.7085C19.7721 2.25976 19.4084 1.896 18.9596 1.896H7.04297C6.59424 1.896 6.23047 2.25976 6.23047 2.7085V10.8335C6.23047 11.2822 5.8667 11.646 5.41797 11.646C4.96924 11.646 4.60547 11.2822 4.60547 10.8335V2.7085Z"
          fill={color}
        />
        <path
          d="M13.0013 4.06266C13.45 4.06266 13.8138 4.42643 13.8138 4.87516V10.4969L15.6768 8.63397C15.9941 8.31667 16.5085 8.31667 16.8258 8.63397C17.1431 8.95127 17.1431 9.46572 16.8258 9.78302L13.5758 13.033C13.4235 13.1854 13.2168 13.271 13.0013 13.271C12.7858 13.271 12.5792 13.1854 12.4268 13.033L9.17678 9.78302C8.85948 9.46572 8.85948 8.95127 9.17678 8.63397C9.49408 8.31667 10.0085 8.31667 10.3258 8.63397L12.1888 10.4969V4.87516C12.1888 4.42643 12.5526 4.06266 13.0013 4.06266Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="icon-incoming-clip">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
